import $store from "@/store";
import { steps } from "@/components/stepper/stepper";


export default function ($route) {
    const updatables = {};


    const integers = {
        apartment_id: $route.query.apartment_id,
        floor: $route.query.floor,

    };
    const strings = {
        email: $route.query.email,
        tel: $route.query.tel,
    };

    for (let [key, value] of Object.entries(integers)) {
        if (value) updatables[key] = parseInt(value)
    }

    for (let [key, value] of Object.entries(strings)) {
        if (value) updatables[key] = value
    }

    $store.commit('SET', updatables)


    if (
        $route.query.step
        && parseInt($route.query.step)
        && parseInt($route.query.step) > 0
        && parseInt($route.query.step) < steps.length
    ) {
        $store.dispatch('setStepByIndex', parseInt($route.query.step))
    }

}
